import React, { useContext, useMemo } from 'react'

import { isArray } from 'lodash'
import { useSelector } from 'react-redux'

import { GlobalContext } from '../../../../Providers/GlobalProvider'
import { isNonEmptyArray } from '../../../../utils'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { LaneTypes } from '../../../../Components/shared/Quotas/utils'

const SectionTooltip = ({ sectionToYears, places, type }) => {
  const { sectionToYearsBySection } = useContext(GlobalContext)
  const t = useSelector(selectTranslate)

  const sectionsTitleData = useMemo(() => sectionToYears.reduce((acc, sty) => {
    const key = sty.section.id ?? -1

    if (!acc[key]) {
      acc[key] = {
        isGrouped: false,
        name: sty.sectionAbbreviation,
        years: []
      }
    }

    acc[key].years.push(sty)

    if (!isArray(sectionToYearsBySection[key])) {
      delete acc[key]
    } else if (type === LaneTypes.GROUP || acc[key].years.length === sectionToYearsBySection[key].length) {
      acc[key].isGrouped = true
    }

    return acc
  }, {}), [sectionToYears, sectionToYearsBySection])

  return (
    <div>
      {t('school_quotas_view.section_tooltip.places', { places: places ?? 0 })}
      {isNonEmptyArray(sectionToYears) && (
        <>
          <br />
          {t('school_quotas_view.section_tooltip.allowed_sections')}
          <ul>
            {Object.values(sectionsTitleData).reduce((acc, sectionTitle, i) => {
              if (sectionTitle.isGrouped) {
                acc.push(<li key={`${i}_${sectionTitle.name}`}>{sectionTitle.name}</li>)
              } else {
                sectionTitle.years.forEach((year, i) => {
                  acc.push(<li key={`${year.id}_${i}`}>{sectionTitle.name + ' (' + year.schoolYearName + ')'}</li>)
                })
              }

              return acc
            }, [])}
          </ul>
        </>
      )}
    </div>
  )
}

export default SectionTooltip
